/* ListHeading.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ListHeading.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useRef } from 'react';
import kebabCase from 'lodash/kebabCase';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var stickySuggestionsGroupHeadingStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var suggestionsGroupHeadingStyles = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var groupHeadingStyles = null;

/**
 * While this component is a simple heading, it's been integrated in case
 * future needs require it to be more complex.
 */
export var ListHeading = function ListHeading(_ref) {
  var heading = _ref.heading;
  var listHeadingRef = useRef(null);
  return /*#__PURE__*/React.createElement("li", {
    ref: listHeadingRef,
    className: ax([fg('ai-smart-button-team-25') ? "_1e0c1txw _ca0qutpp _19bvpxbi _u5f3pxbi _n3td1b66 _1yvt2smr _puxi1wq8 _1m59131l" : "_1e0c1txw _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qutpp _u5f3utpp _n3td1b66 _19bvutpp _1d6oidpf _4cd9idpf _zmksidpf _1l8widpf _1yvt1o8v _1k8imoej _k4hmangw _1m591gjq", "_kqsw1if8 _1bsb1kw7 _154iidpf _bfhkvuon _1pbykb7n"])
  }, /*#__PURE__*/React.createElement("h3", {
    className: "list-heading-text",
    "data-testid": "list-heading-".concat(kebabCase(heading))
  }, heading));
};